/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function blockedSuppliers(instance) {
	return {
		/**
		 * @param {number} retailerId
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 */
		getRetailerBlockedSuppliers: (
			retailerId,
			pageNumber,
			pageSize,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/blocked_farms${params}`,
				config
			)
		},

		/**
		 * @param {number} retailerId
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 */
		getAllAvailable: (retailerId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/blocked_farms/available${params}`,
				config
			)
		},

		/**
		 * @param {number} retailerId
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 */
		getNonBlockRetailerFarms: (retailerId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/blocked_farms/non_blocked${params}`,
				config
			)
		},

		/**
		 * @param {object} body
		 */
		create: (body, config = {}) => {
			return instance.post(`retailers/blocked_farms`, body, config)
		},

		/**
		 * @param {object} id
		 */
		delete: (id, config = {}) => {
			return instance.delete(`retailers/blocked_farms/${id}`, config)
		}
	}
}
